
// src/components/LeverageSolvencyMetrics.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const LeverageSolvencyMetrics = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'Current Ratio': 'N/A',
    'Quick Ratio': 'N/A',
    'Operating Cash Flow Ratio': 'N/A',
    'Working Capital': 'N/A',
    'Debt-to-Equity': 'N/A',
    'Debt-to-Assets': 'N/A',
    'Net Debt/EBITDA': 'N/A',
    'Equity Multiplier': 'N/A',
    'Interest Coverage Ratio': 'N/A',
    'Altman Z-Score': 'N/A',
    'Financial Leverage': 'N/A',
    'Fixed Charge Coverage': 'N/A',
  };

  // Here the same map is used both for formatting and for tooltip text lookup
  const definitionKeyMap = {
    'Current Ratio': 'currentRatio',
    'Quick Ratio': 'quickRatio',
    'Operating Cash Flow Ratio': 'operatingCashflowRatio',
    'Working Capital': 'workingCapital',
    'Debt-to-Equity': 'debtToEquity',
    'Debt-to-Assets': 'debtToAssets',
    'Net Debt/EBITDA': 'netDebtToEbitda',
    'Equity Multiplier': 'equityMultiplier',
    'Interest Coverage Ratio': 'interestCoverage',
    'Altman Z-Score': 'altmanZScore',
    'Financial Leverage': 'financialLeverage',
    'Fixed Charge Coverage': 'fixedChargeCoverage',
  };

  const displayMetrics = {};
  Object.entries(defaultMetrics).forEach(([label, fallback]) => {
    const backendKey = definitionKeyMap[label];
    const value = backendKey && metricsData ? metricsData[backendKey] : null;
    displayMetrics[label] = value !== undefined && value !== null ? value : fallback;
  });

  return (
    <div className="w-full my-4">
      <div className="card p-5 min-h-[625px]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-advanced-leverage rounded-full" />
          <h2 className="section-heading">
            Leverage | Solvency | Liquidity{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((label, index) => {
            const defKey = definitionKeyMap[label];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-advanced-leverage-light border border-rose-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${label}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {label}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-advanced-leverage-dark text-right break-words">
                  {formatNumber(label, displayMetrics[label], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LeverageSolvencyMetrics;











